import {Project} from './project';

export class CurrentContext {
  project:Project;
  qId:number;
  tId:number;
  terminalTypeId:number;

  constructor() {}
}
